import React, { useState } from "react";
import { toast } from "react-toastify";
import Loading from "./common/loading";
import Input from "./common/input";
import ListGroup from "./common/listGroup";
import http from "../services/http";

const DataSummary = () => {
  const [data, setData] = useState([]);
  const [site, setSite] = useState({ id: "WI" });
  const [code, setCode] = useState("DY-NO-V-0T");
  const [operationType, setOperationType] = useState({ id: "BC" });
  const [aggregateType, setAggregateType] = useState({
    id: "MAX",
    name: "Max",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const sites = [
    { id: "BA", name: "Bardney" },
    { id: "BU", name: "Bury" },
    { id: "CA", name: "Cantley" },
    { id: "NE", name: "Newark" },
    { id: "WI", name: "Wissington" },
  ];

  const operationTypes = [
    { id: "BC", name: "Campaign" },
    { id: "JR", name: "Juice Run" },
  ];

  const aggregateTypes = [
    { id: "AVG", name: "Average" },
    { id: "SUM", name: "Sum" },
    { id: "MIN", name: "Min" },
    { id: "MAX", name: "Max" },
    { id: "STDDEV", name: "Standard Deviation" },
  ];

  const handleFetch = async (e) => {
    e.preventDefault();

    if (!code) return setErrors({ code: "invalid Code" });

    setLoading(true);
    try {
      const { data } = await http.get(
        `/data-summary/${site.id}/${code}/${operationType.id}/${aggregateType.id}`
      );
      setData(data);
    } catch (ex) {
      if (ex.response && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    setLoading(false);
  };

  return (
    <div className="col-10 mt-4">
      <div className="row">
        <form className="container">
          <div className="form-row">
            <div className="col-auto">
              <ListGroup
                items={sites}
                onItemSelect={(i) => setSite(i)}
                selectedItem={site}
              />
            </div>
            <div className="col">
              <ListGroup
                items={operationTypes}
                onItemSelect={(i) => setOperationType(i)}
                selectedItem={operationType}
              />
            </div>
          </div>
          <div className="form-row">
            <ListGroup
              items={aggregateTypes}
              onItemSelect={(i) => setAggregateType(i)}
              selectedItem={aggregateType}
            />
          </div>
          <div className="form-row">
            <Input
              name="code"
              label="Parameter Code"
              placeholder="Code"
              value={code}
              onChange={(e) => setCode(e.currentTarget.value)}
              error={errors.code}
            />
          </div>
          <div className="form-row">
            <button className="btn btn-primary" onClick={handleFetch}>
              Get Data
            </button>
          </div>
        </form>
      </div>
      {loading && <Loading />}
      <div className="row">
        <div className="container">
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Parameter</th>
                <th>Operation Code</th>
                <th>Year</th>
                <th>{aggregateType.name}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((d) => (
                <tr key={d.YEAR}>
                  <td>{d.PARAMETER}</td>
                  <td>{d.OPERATION_CODE}</td>
                  <td>{d.YEAR}</td>
                  <td>
                    {d[aggregateType.id] &&
                      d[aggregateType.id].toFixed(d.PRECISION)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DataSummary;
